/**
 * BeBobi — sztywna podłoga jako dodatek na PDP materacyka.
 * Kafle Tak/Nie tylko trzymają wybór; sama podłoga dokładana jest DOPIERO po
 * udanym dodaniu materacyka (nasłuch cart:update ze źródła product-form-component,
 * wzorzec z bebobi-upsell.js), jako zwykła pełnopłatna pozycja "Osobno" —
 * bez properties _bb*, więc reconciler koszyka słusznie ją ignoruje i klient
 * może ją swobodnie edytować. Rozmiar podłogi podąża za rozmiarem materacyka.
 */
import { ThemeEvents, CartAddEvent } from '@theme/events';

class BebobiFloorAddon extends HTMLElement {
  connectedCallback() {
    this.variants = [];
    try {
      const raw = this.querySelector('[data-fa-variants]');
      if (raw) this.variants = JSON.parse(raw.textContent);
    } catch (_) { this.variants = []; }
    this.on = false;
    this.btns = [...this.querySelectorAll('[data-fa-choice]')];
    this.note = this.querySelector('[data-fa-note]');
    this.btns.forEach((b) => b.addEventListener('click', () => {
      this.on = b.dataset.faChoice === 'yes';
      this.btns.forEach((x) => x.classList.toggle('is-selected', (x.dataset.faChoice === 'yes') === this.on));
      if (this.note) this.note.hidden = !this.on;
    }));

    this._onCart = (e) => {
      const d = (e.detail && e.detail.data) || {};
      if (d.source !== 'product-form-component' || !this.on || this._busy) return;
      this.addFloor();
    };
    document.addEventListener(ThemeEvents.cartUpdate, this._onCart);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this._onCart);
  }

  /** rozmiar materacyka z zaznaczonego radia Rozmiar (S → S, reszta → M/L) */
  wantedSize() {
    for (const inp of document.querySelectorAll('input[type="radio"]')) {
      const n = (inp.name || '').toLowerCase();
      if ((n.startsWith('rozmiar') || n.startsWith('size')) && inp.checked) {
        return inp.value.trim().toUpperCase() === 'S' ? 'S' : 'M/L';
      }
    }
    return 'M/L';
  }

  async addFloor() {
    const want = this.wantedSize();
    const eq = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
    const v = this.variants.find((x) => eq(x.rozmiar, want) && x.available !== false);
    if (!v) return; // rozmiar chwilowo niedostępny — materacyk został dodany normalnie
    const boards = Number(v.boards) || 1;
    this._busy = true;
    try {
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId).filter(Boolean);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        /* The warehouse packs 3 boards per floor, so the line counts BOARDS
           (the bebobi-packin-free function zeroes 2 of every 3, leaving the
           customer paying one board's price). This is a standalone purchase -
           no _bb* properties - so planFloorOps in bebobi-cart-bundles.js keeps
           the quantity on whole sets from here on. */
        body: JSON.stringify({ items: [{ id: v.id, quantity: boards, properties: { _bbSets: '1' } }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      if (!res.ok) return;
      const data = await res.json();
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(new CartAddEvent(cart, 'bebobi-floor-addon', {
        source: 'bebobi-floor-addon',
        itemCount: cart.item_count,
        sections: data.sections,
      }));
    } catch (_) { /* dodatek nie może blokować głównego zakupu */ } finally {
      this._busy = false;
    }
  }
}

if (!customElements.get('bebobi-floor-addon')) {
  customElements.define('bebobi-floor-addon', BebobiFloorAddon);
}
